module.exports = __webpack_public_path__ + "img/titulo-documentos.858d353a.png";